import { render, staticRenderFns } from "./channel_product.vue?vue&type=template&id=2d75b1ea&scoped=true&"
import script from "./channel_product.vue?vue&type=script&lang=js&"
export * from "./channel_product.vue?vue&type=script&lang=js&"
import style0 from "./channel_product.vue?vue&type=style&index=0&id=2d75b1ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75b1ea",
  null
  
)

export default component.exports